module.exports = __webpack_public_path__ + "static/media/kruzer.d6fc010a.svg";